/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

import { Component, Input } from '@angular/core';

import './log-cinematic-end-to-end-knot.component.less';

/**
 * @description
 *     Component for the end-to-end knot in log cinematic view. The template comprises a header and
 *     a fixed-size icon.
 * @author Zhiqian Liu
 */
@Component({
    selector: 'log-cinematic-end-to-end-knot',
    templateUrl: './log-cinematic-end-to-end-knot.component.html',
})
export class LogCinematicEndToEndKnotComponent {
    @Input()
    public headerText: string;

    @Input()
    public topHeaderColor?: string;

    @Input()
    public iconShape: string;

    @Input()
    public iconStatus?: string;

    @Input()
    public iconBadge?: string;
}
